interface StatTileProps {
  label: string;
  value: string;
  sublabel?: string;
  tone?: "default" | "gold" | "sell" | "turquoise" | "profit";
}
const TONE_CLASS: Record<NonNullable<StatTileProps["tone"]>, string> = {
  default: "text-ink",
  gold: "text-gold",
  sell: "text-sell",
  turquoise: "text-turquoise",
  profit: "text-profit",
};
export default function StatTile({ label, value, sublabel, tone = "default" }: StatTileProps) {
  return (
    <div className="min-w-0 rounded-lg border border-line bg-panel px-4 py-3 shadow-panel">
      <div className="truncate font-mono text-[11px] uppercase tracking-wider text-ink-faint">{label}</div>
      <div className={`mt-1 break-all font-mono text-xl font-semibold tabular ${TONE_CLASS[tone]}`}>{value}</div>
      {sublabel && <div className="mt-0.5 break-words text-[11px] text-ink-dim">{sublabel}</div>}
    </div>
  );
}
